import React from 'react'
import useRolesViews from 'hooks/useRolesViews'
import ShiftPlanHeader from 'redesign/components/organisms/headers/ShiftPlanHeader'
import Page from 'redesign/components/templates/Page'
import ShiftPlanTemplate from 'redesign/components/templates/ShiftPlanContent/ShiftPlanTemplate'
import { QUERIES_TO_REFETCH } from 'redesign/components/templates/ShiftPlanContent/constants'
import SideMenu from 'redesign/components/templates/SideMenu'
import { PARENT_PAGES } from 'redesign/components/templates/SideMenu/constants'
import FiltersStorageProvider from 'redesign/services/FiltersStorage/FiltersStorageProvider'
import SideMenuProvider from 'redesign/services/SideMenu/SideMenuProvider'
import SwipeableViewProvider from 'redesign/services/SwipeableView/SwipeableViewProvider'
import { isNative } from 'utils/platform'
import { useApolloClient } from '@apollo/client'
import { SHIFT_PLAN_PAGE_ROOT_ID } from './constants'

const ShiftPlanPage: React.FC = () => {
  const isNativeView = isNative()
  const { persons } = useRolesViews()

  const client = useApolloClient()
  const onRefresh = async () =>
    client.refetchQueries({
      include: QUERIES_TO_REFETCH,
    })

  return (
    <FiltersStorageProvider>
      <SideMenuProvider parentPage={PARENT_PAGES.shiftPlan} persons={persons}>
        <SwipeableViewProvider>
          <Page header={<ShiftPlanHeader />} noPadding removeLastMargin rootId={SHIFT_PLAN_PAGE_ROOT_ID}>
            <ShiftPlanTemplate isNative={isNativeView} onRefresh={onRefresh} />
            <SideMenu onRefresh={onRefresh} />
          </Page>
        </SwipeableViewProvider>
      </SideMenuProvider>
    </FiltersStorageProvider>
  )
}

export default ShiftPlanPage
